export default __webpack_public_path__ + "static/media/avatar_fairy_pixie8.a6e0645d.mp3";